import { defineStore } from 'pinia';
import api from '@/services/api';
import {
  initialCylinderAdapter,
  initial_filters,
} from '../models/cylinder_adapter_model.js';
import { getParamsUrl } from '../cylinder_adapters_utils.js';

export const useCylinderAdapterStore = defineStore('cylinderAdapterStore', {
  state: () => ({
    cylinderAdapter: { ...initialCylinderAdapter },
    cylinderAdapterFilters: { ...initial_filters },
    cylinderAdapterList: [],
    page: 1,
    validateCylinderAdapterFields: {
      CodigoCilindroTipo: true,
      Dientes: true,
      Paso: true,
    },
  }),

  actions: {
    setDuplicateValidation() {
      this.validateCylinderAdapterFields.CodigoCilindroTipo = false;
      this.validateCylinderAdapterFields.Dientes = false;
      this.validateCylinderAdapterFields.Paso = false;
    },
    isDuplicateError(error) {
      return (
        error?.response?.status === 409 &&
        error?.response?.data?.code === 'CYLINDER_ADAPTER_DUPLICATE'
      );
    },
    resetValidations() {
      Object.keys(this.validateCylinderAdapterFields).forEach((key) => {
        this.validateCylinderAdapterFields[key] = true;
      });
    },
    validarCampos() {
      this.validateCylinderAdapterFields.CodigoCilindroTipo =
        !!this.cylinderAdapter.CodigoCilindroTipo;
      this.validateCylinderAdapterFields.Dientes =
        this.cylinderAdapter.Dientes !== null && this.cylinderAdapter.Dientes > 0;
      this.validateCylinderAdapterFields.Paso =
        this.cylinderAdapter.Paso !== null && this.cylinderAdapter.Paso > 0;

      return (
        this.validateCylinderAdapterFields.CodigoCilindroTipo &&
        this.validateCylinderAdapterFields.Dientes &&
        this.validateCylinderAdapterFields.Paso
      );
    },
    async findAllCilindroAdaptadorHTTP() {
      const result = await api.get(
        `/cilindro-adaptador?${getParamsUrl({ ...this.cylinderAdapterFilters, page: +this.page })}`,
      );
      if (result && result.data && result.data.length > 0) {
        this.cylinderAdapterList.push(...result.data);
        this.setPage(this.page + 1);
        return true;
      }
      return false;
    },
    async findOneCilindroAdaptadorHTTP(codigo) {
      const result = await api.get(`/cilindro-adaptador/${codigo}`);
      if (result && result.data) {
        this.cylinderAdapter = result.data;
        return true;
      }
      return false;
    },
    async updateCilindroAdaptadorHTTP() {
      const data = {
        CodigoCilindroTipo: this.cylinderAdapter.CodigoCilindroTipo,
        Dientes: this.cylinderAdapter.Dientes,
        Paso: this.cylinderAdapter.Paso,
      };

      try {
        const response = await api.patch(
          `/cilindro-adaptador/${this.cylinderAdapter.Codigo}`,
          data,
        );
        if (response.status === 200) {
          this.resetCilindroAdaptador();
          return response;
        }
      } catch (error) {
        if (this.isDuplicateError(error)) {
          this.setDuplicateValidation();
        }
        throw error;
      }
    },
    async newCilindroAdaptadorHTTP() {
      const data = {
        CodigoCilindroTipo: this.cylinderAdapter.CodigoCilindroTipo,
        Dientes: this.cylinderAdapter.Dientes,
        Paso: this.cylinderAdapter.Paso,
      };

      try {
        const response = await api.post('/cilindro-adaptador', data);
        if (response.status === 200 || response.status === 201) {
          this.resetCilindroAdaptador();
          return response;
        }
        throw response;
      } catch (error) {
        if (this.isDuplicateError(error)) {
          this.setDuplicateValidation();
        }
        throw error;
      }
    },
    async deleteCilindroAdaptadorHTTP(codigo) {
      const response = await api.delete(`/cilindro-adaptador/${codigo}`);
      if (response.status === 200 || response.status === 204) {
        return true;
      }
      return false;
    },
    async firstCilindroAdaptador() {
      this.setPage(1);
      this.emptyList();
      await this.findAllCilindroAdaptadorHTTP();
    },
    resetCilindroAdaptador() {
      this.cylinderAdapter = JSON.parse(JSON.stringify(initialCylinderAdapter));
    },
    setPage(page) {
      this.page = page;
    },
    emptyList() {
      this.cylinderAdapterList = [];
    },
    resetFilter() {
      this.cylinderAdapterFilters = { ...initial_filters };
    },
  },
});
